import { START_TIMER, STOP_TIMER } from 'redux-timer-middleware';

import * as types from '../../constants/ActionTypes';


export const forgotPIN = () => ({
    type: types.FORGOT_PIN,
});

export const resetForgottenPIN = action => ({
    type: types.RESET_FORGOTTEN_PIN_REQUEST,
    conversationHash: action,
});

export const resetForgottenPINSuccess = action => ({
    type: types.RESET_FORGOTTEN_PIN_SUCCESS,
    ...action,
});

export const resetForgottenPINFailure = error => ({
    type: types.RESET_FORGOTTEN_PIN_FAILURE,
    error: {
        message: error.data.error,
    },
});

export const limitedLogin = request => ({
    type: types.LIMITED_LOGIN_REQUEST,
    ...request,
});

export const limitedLoginSuccess = response => ({
    type: types.LIMITED_LOGIN_SUCCESS,
    response,
});

export const startLimitedLoginMessageTimer = request => ({
    type: START_TIMER,
    payload: request,
});

export const stopLimitedLoginMessageTimer = request => ({
    type: STOP_TIMER,
    payload: request,
});

export const login = request => ({
    type: types.LOGIN_REQUEST,
    ...request,
});

export const logout = () => ({
    type: types.LOGOUT_REQUEST,
});

export const loginSuccess = response => ({
    type: types.LOGIN_SUCCESS,
    response,
});

export const loginFailure = error => ({
    type: types.LOGIN_FAILURE,
    error: {
        message: error.response.data.message,
        retryCount: error.response.data.retryCount,
    },
});

export const getConversationDetails = conversationHash => ({
    type: types.GET_CONVERSATION_DETAILS,
    conversationHash,
});

export const getConversationDetailsSuccess = action => ({
    type: types.GET_CONVERSATION_DETAILS_SUCCESS,
    ...action,
});

export const getConversationDetailsFailure = error => ({
    type: types.GET_CONVERSATION_DETAILS_FAILURE,
    error: {
        message: error.data.error,
    },
});

export const savePIN = request => ({
    type: types.SAVE_PIN_REQUEST,
    ...request,
});

export const savePINSuccess = action => ({
    type: types.SAVE_PIN_SUCCESS,
    ...action,
});

export const getSessionTime = () => ({
    type: types.SESSION_TIME_REQUEST,
});

export const getSessionTimeSuccess = response => ({
    type: types.SESSION_TIME_SUCCESS,
    response,
});

export const verifyDOB = request => ({
    type: types.VERIFY_DOB_REQUEST,
    ...request,
});

export const verifyDOBSuccess = action => ({
    type: types.VERIFY_DOB_SUCCESS,
    verifiedDOB: action,
});

export const verifyName = request => ({
    type: types.VERIFY_NAME_REQUEST,
    ...request,
});

export const verifyNameSuccess = action => ({
    type: types.VERIFY_NAME_SUCCESS,
    verifiedName: action,
});
